export default __webpack_public_path__ + "static/media/bit4.6e7fdbc7.svg";